@if (_isNativeHtmlTable) {
  <thead role="rowgroup">
    <ng-container headerRowOutlet />
  </thead>
  <tbody role="rowgroup">
    <ng-container rowOutlet />
    <ng-container noDataRowOutlet />
  </tbody>
  <tfoot role="rowgroup">
    <ng-container footerRowOutlet />
  </tfoot>
} @else {
  <ng-container headerRowOutlet />
  <ng-container rowOutlet />
  <ng-container noDataRowOutlet />
  <ng-container footerRowOutlet />
}
